"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _get = _interopRequireDefault(require("lodash/get"));
var _styles = require("@material-ui/core/styles");
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _clsx = _interopRequireDefault(require("clsx"));
var _resizeListener = _interopRequireDefault(require("../resizeListener"));
var _menu = require("../utilities/menu");
var _styles2 = require("../utilities/styles");
var _map = _interopRequireDefault(require("../poly/map"));
var _count = _interopRequireDefault(require("../poly/count"));
var _button = _interopRequireDefault(require("../button"));
var _excluded = ["render", "className", "buttonClasses", "items", "getItemChildren", "getItemKey", "ButtonComponent", "collapsible", "overflow", "flexEnd"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var NUMBER_REGEXP = /[^0-9]+/;
var useClasses = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      overflow: function overflow(_ref) {
        var _overflow = _ref.overflow;
        return _overflow ? null : 'hidden';
      },
      whiteSpace: 'nowrap',
      display: function display(_ref2) {
        var flexEnd = _ref2.flexEnd;
        return flexEnd ? 'flex' : null;
      },
      justifyContent: function justifyContent(_ref3) {
        var flexEnd = _ref3.flexEnd;
        return flexEnd ? 'flex-end' : null;
      }
    },
    text: (0, _defineProperty2.default)({
      fontSize: '1em',
      marginRight: '30px'
    }, theme.breakpoints.up('lg'), {
      marginRight: '50px',
      fontSize: '1.33em'
    }),
    moreButtonChildText: {
      marginRight: 0,
      marginBottom: '20px'
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px 20px 0 20px',
      width: 'auto'
    },
    caret: {
      marginLeft: '10px'
    }
  };
}, {
  classNamePrefix: 'TCUINavigationLinks'
});
var NavigationLinks = /*#__PURE__*/(0, _react.forwardRef)(function (_ref4, ref) {
  var render = _ref4.render,
    className = _ref4.className,
    buttonClasses = _ref4.buttonClasses,
    items = _ref4.items,
    getItemChildren = _ref4.getItemChildren,
    getItemKey = _ref4.getItemKey,
    ButtonComponent = _ref4.ButtonComponent,
    collapsible = _ref4.collapsible,
    overflow = _ref4.overflow,
    flexEnd = _ref4.flexEnd,
    rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  var _useState = (0, _react.useState)((0, _count.default)(items)),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    maxVisible = _useState2[0],
    setMaxVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    popperVisible = _useState4[0],
    setPopperVisible = _useState4[1];
  var navRef = (0, _react.useRef)(null);
  var moreButtonRef = (0, _react.useRef)(null);
  var popperRef = (0, _react.useRef)(null);
  var _classes = useClasses({
    overflow: overflow,
    flexEnd: flexEnd
  });
  var _render = (0, _react.useCallback)(function () {
    return (0, _map.default)(function (item, i, slicedItems) {
      var key = getItemKey(item, i, slicedItems);
      return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, rest, {
        ref: ref,
        key: key,
        "aria-label": (0, _menu.getItemLabel)(item),
        href: item.url,
        target: item.target,
        component: ButtonComponent,
        classes: (0, _styles2.mergeClasses)({
          text: _classes.text
        }, buttonClasses)
      }), (0, _menu.getItemLabel)(item));
    }, items.slice(0, maxVisible));
  }, [items, _classes.text, ButtonComponent, buttonClasses, getItemKey, getItemChildren, maxVisible, ref, rest]);
  var renderMore = (0, _react.useCallback)(function () {
    if ((0, _count.default)(items) <= maxVisible) return null;
    var handleMoreClick = function handleMoreClick() {
      return setPopperVisible(!popperVisible);
    };
    var handleBlur = function handleBlur(event) {
      if (!popperVisible) return;
      if (moreButtonRef.current === document.activeElement) return;
      var popperElem = popperRef.current;
      if (popperElem.contains(event.relatedTarget)) return;
      setPopperVisible(false);
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, rest, {
      buttonRef: moreButtonRef,
      classes: (0, _styles2.mergeClasses)({
        text: _classes.text
      }, buttonClasses),
      onClick: handleMoreClick,
      onBlur: handleBlur
    }), "More", /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['tcs', 'arrow-down'],
      size: "xs",
      style: {
        height: '1em'
      },
      className: (0, _clsx.default)(_classes.caret, {
        'rotate-180-cw': popperVisible
      }, {
        'rotate-0': !popperVisible
      })
    })), /*#__PURE__*/_react.default.createElement(_Popper.default, {
      disablePortal: true,
      anchorEl: moreButtonRef.current,
      ref: popperRef,
      open: popperVisible,
      placement: "bottom-start",
      popperOptions: {
        modifiers: {
          preventOverflow: {
            enabled: true,
            padding: 0
          },
          offset: {
            enabled: true,
            offset: '-20px, 100%r'
          }
        }
      }
    }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
      onBlur: handleBlur,
      className: _classes.paper
    }, (0, _map.default)(function (item, i, slicedItems) {
      return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, rest, {
        key: getItemKey(item, i, slicedItems),
        "aria-label": (0, _menu.getItemLabel)(item),
        href: item.url,
        target: item.target,
        component: ButtonComponent,
        classes: (0, _styles2.mergeClasses)({
          text: (0, _clsx.default)(_classes.text, _classes.moreButtonChildText)
        }, buttonClasses)
      }), (0, _menu.getItemLabel)(item));
    }, items.slice(maxVisible)))));
  }, [_classes.caret, _classes.moreButtonChildText, _classes.text, _classes.moreContainer, _classes.paper, buttonClasses, getItemKey, items, maxVisible, ButtonComponent, popperVisible, moreButtonRef, rest, ref]);
  var calculateVisibleLinks = (0, _debounce.default)(function () {
    if (!(0, _get.default)(navRef, 'current')) return;
    var totalChildrenWidth = 0;
    var navWidth = navRef.current.getBoundingClientRect().width;
    var childNodes = navRef.current.childNodes;
    for (var childIndex = 0; childIndex < childNodes.length; childIndex++) {
      var child = childNodes[childIndex];
      var style = window.getComputedStyle(child);
      totalChildrenWidth += child.getBoundingClientRect().width + parseInt(style.marginRight.replace(NUMBER_REGEXP, '')) + parseInt(style.marginLeft.replace(NUMBER_REGEXP, ''));
      if (totalChildrenWidth > navWidth) {
        setMaxVisible(childIndex - 1);
        return;
      }
    }
  });
  var onResize = (0, _react.useCallback)(function () {
    setMaxVisible((0, _count.default)(items));
    setPopperVisible(false);
    calculateVisibleLinks();
  }, [items, calculateVisibleLinks]);
  var renderedItems = render ? (0, _map.default)(render, items) : _render();
  return /*#__PURE__*/_react.default.createElement("nav", {
    ref: navRef,
    role: "navigation",
    className: (0, _clsx.default)(_classes.root, className)
  }, collapsible ? /*#__PURE__*/_react.default.createElement(_resizeListener.default, {
    onResize: onResize,
    debounceWait: 500
  }, /*#__PURE__*/_react.default.createElement("div", null, renderedItems, renderMore())) : renderedItems);
});
NavigationLinks.propTypes = {
  render: _propTypes.default.func,
  className: _propTypes.default.string,
  butonClasses: _propTypes.default.object,
  items: _propTypes.default.array,
  getItemChildren: _propTypes.default.func,
  getItemKey: _propTypes.default.func,
  ButtonComponent: _propTypes.default.object,
  collapsible: _propTypes.default.bool,
  buttonClasses: _propTypes.default.object,
  overflow: _propTypes.default.bool,
  flexEnd: _propTypes.default.bool
};
NavigationLinks.defaultProps = {
  render: null,
  className: null,
  buttonClasses: {},
  items: [],
  getItemChildren: function getItemChildren() {
    return null;
  },
  getItemKey: function getItemKey(_ref5) {
    var id = _ref5.id;
    return id;
  },
  ButtonComponent: undefined,
  collapsible: false,
  overflow: false,
  flexEnd: false
};
var _default = NavigationLinks;
exports.default = _default;